import './index.css'
import CloseButton from 'src/components/common/CloseButton'
import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import CustomPagination from 'src/components/common/custom-components/CustomPagination'
import MemberDetailRow from 'src/components/common/MemberDetails/MemberDetailsRow'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { MEMBER_PAGE_DETAILS } from 'src/services/individualService'
import { CustomSearch } from 'src/components/common/custom-components/CustomSearch'
import {
  membersColumns,
  membersColumnsCEO,
  NO_DATA,
  PLEASE_WAIT_WHILE_FETCHING,
} from 'src/utils/constants/common'

const ViewAllMemberDetails = ({
  closeModal,
  isCompanyPolicy,
  isCEO,
  policyId,
  clientId,
}) => {
  const [filters, setFilters] = useState({
    page: 1,
    rowsPerPage: 25,
    searchValue: '',
  })

  const [memberList, setMemberList] = useState([{}])

  const {
    loading: annexureDetailsLoading,
    error: annexureDetailsError,
    data: annexureDetailsData,
    refetch,
  } = useQuery(MEMBER_PAGE_DETAILS(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    variables: {
      policyID: policyId,
      clientId: clientId,
      search: filters?.searchValue,
      page: filters?.page - 1,
      size: filters?.rowsPerPage,
      viewForCEO: isCEO,
    },
  })

  const applyFilters = (event) => {
    setFilters({
      ...filters,
      ...event,
    })
  }

  const handleChangePage = (newPage) => {
    applyFilters({
      ...filters,
      page: newPage,
    })
  }

  const handleChangeRowsPerPage = (rows) => {
    applyFilters({
      ...filters,
      page: 1,
      rowsPerPage: rows,
    })
  }

  const handleSearch = (searchText) => {
    applyFilters({
      ...filters,
      searchValue: searchText,
    })
  }

  useEffect(() => {
    refetch({
      policyID: policyId,
      clientId: clientId,
      search: filters?.searchValue,
      page: filters?.page - 1,
      size: filters?.rowsPerPage,
      viewForCEO: isCEO,
    })
  }, [filters, refetch, policyId, clientId, isCEO])

  useEffect(() => {
    setMemberList(annexureDetailsData?.getMemberPage?.content || [])
  }, [annexureDetailsData])

  if (annexureDetailsError)
    return <GraphQlErrors error={annexureDetailsError} />

  return (
    <div className='view-all-root'>
      <div className='view-all-title-container'>
        <CloseButton
          title='Close'
          handleClose={closeModal}
          classname='close-button'
        />
        <div className='view-all-title'>Member Details</div>
      </div>

      <div className='view-all-search-div'>
        <CustomSearch
          id='searchBar'
          value={filters.searchValue}
          onSearch={handleSearch}
          placeHolder={' Search by Id, name, mobile number'}
        />
      </div>

      <div className='view-all-list-container'>
        <div className='view-all-table-heading-container  '>
          {isCompanyPolicy
            ? membersColumnsCEO?.map((column) => {
                return (
                  <span className='view-all-table-heading' key={column}>
                    {column}
                  </span>
                )
              })
            : membersColumns?.map((column) => {
                return (
                  <span className='view-all-table-heading' key={column}>
                    {column}
                  </span>
                )
              })}
        </div>

        <div className='view-all-member-list-container'>
          {memberList?.length ? (
            memberList?.map((member) => {
              return (
                <div key={member?.empId} className='view-all-member-row'>
                  <MemberDetailRow
                    isCompanyPolicy={isCompanyPolicy}
                    member={member}
                  />
                </div>
              )
            })
          ) : (
            <div className='no-data-text'>
              {annexureDetailsLoading ? PLEASE_WAIT_WHILE_FETCHING : NO_DATA}
            </div>
          )}
        </div>
      </div>

      <div className='view-all-pagination-container'>
        {memberList?.length ? (
          <CustomPagination
            totalCount={
              annexureDetailsData?.getMemberPage?.pageInfo?.totalCount || 0
            }
            rowsPerPage={filters?.rowsPerPage}
            page={filters?.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ViewAllMemberDetails
